// extracted by mini-css-extract-plugin
export default {"root":"DisplayBoxedField_root__3L4I6","form":"DisplayBoxedField_form__W1Rv1","textfield":"DisplayBoxedField_textfield__G09Gm"};